import * as React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import Tooltip from '@mui/material/Tooltip';
export type ChartType = 'bar' | 'pie';

type ChartTypeToggleProps = {
  value: ChartType;
  onChange: (value: ChartType) => void;
  sx?: any;
};

const options: { value: ChartType; label: string; icon: React.ReactNode }[] = [
  { value: 'bar', label: 'Гистограмма', icon: <BarChartIcon /> },
  { value: 'pie', label: 'Круговая', icon: <PieChartIcon /> },
];

export default function ChartTypeToggle({ value, onChange, sx }: ChartTypeToggleProps) {
  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: ChartType | null) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup value={value} exclusive onChange={handleChange} sx={sx}>
      {options.map(opt => (
        <Tooltip key={opt.value} title={opt.label}>
          <ToggleButton value={opt.value} aria-label={opt.label}>
            {opt.icon}
          </ToggleButton>
        </Tooltip>
      ))}
    </ToggleButtonGroup>
  );
}
